// DEPENDENCIES
import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import _ from 'lodash';
// COMPONENTS
import {
    DragDropContext,
    Droppable,
    Draggable
} from 'react-beautiful-dnd';
import Modal from 'react-bootstrap/Modal';
// CUSTOM COMPONENTS
import LoadingScreen from '../../components/LoadingScreen';
import Section from '../../components/Section';
import FormBlock from '../../components/FormBlock';
import ContentBlock from '../../components/ContentBlock';
import CustomBlock from '../../components/CustomBlock';
import ContentHeader from '../../components/ContentHeader';
import InputBlock from '../../components/InputBlock';
import SelectBlock from '../../components/SelectBlock';
import TextAreaBlock from '../../components/TextAreaBlock';
import FileUploadBlock from '../../components/FileUploadBlock';
import CheckboxBlock from '../../components/CheckboxBlock';
import Button from '../../components/Button';
import Image from '../../components/Image';
// SERVICES AND HELPERS
import { Alert } from '../../helpers/Alert';
import * as Helper from '../../helpers/helper';
import ProductCreateValidator from '../../helpers/validators/product-management/ProductCreateValidator';
import * as CompanyService from '../../services/company.service';
import * as CategoryService from '../../services/category.service';
import * as ProductService from '../../services/product.service';
import constants from '../../constants/constants';

var timeoutId = 0;
var categoryId = 0;

const CreateNewProductPage = (props) => {
    const role = Helper.LoggedInUserRole();
    const companyId = Helper.LoggedInCompanyId();

    const { location } = props
    const urlId = location.pathname.split('/').pop();
    const [productId, setProductId] = useState(parseInt(urlId) == urlId ? urlId : 0);
    const [isSortModalOpen, setIsSortModalOpen] = useState(false);
    const [sortList, setSortList] = useState([]);
    const initialState = {
        id: 0,
        name: "",
        categoryId: 0,
        audienceSize: "",
        price: "",
        description: "",
        bestUsedFor: "",
        imageFiles: [],
        sampleVideoFile: [],
        salesVideoFile: [],
        canBeBonus: false,
        hasServiceDuration: false,
        isActive: true,
        usesFreeInput: false,
        companyId: companyId
    }

    const [loading, setLoading] = useState(false);
    const [isChecking, setIsChecking] = useState(false);
    const [isUsed, setIsUsed] = useState(false);
    const [isDisabled, setIsDisabled] = useState(role == 'User');

    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(companyId);

    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState();

    const [product, setProduct] = useState(initialState);

    const [primaryImageFile, setPrimaryImageFile] = useState(null);
    const [primaryImagePath, setPrimaryImagePath] = useState(null);

    const [imageFiles, setImageFiles] = useState(null);
    const [imageFilePaths, setImageFilePaths] = useState(null);

    const [sampleVideoFile, setSampleVideoFile] = useState(null);
    const [sampleVideoPath, setSampleVideoPath] = useState(null);

    const [salesVideoFile, setSalesVideoFile] = useState(null);
    const [salesVideoPath, setSalesVideoPath] = useState(null);

    useEffect(() => {
        if (imageFilePaths) {
            setSortList(imageFilePaths.sort((a, b) => a.sortOrder - b.sortOrder));
        }
    }, [imageFilePaths]);

    useEffect(() => {
        setLoading(true);
        if (productId > 0) {
            GetProductById();
        }
        else
            LoadCompanies(selectedCompany);
    }, []);

    const GetProductById = async () => {
        await ProductService.Get(productId).then(res => {
            SetDataFromProduct(res);
            LoadCompanies(res.companyId);
            LoadCategories(res.companyId);
        }).catch(ex => {
            setLoading(false);
        });
    }

    const SetDataFromProduct = (product) => {
        setPrimaryImagePath(_.find(product.productImage, x => x.isPrimary));
        setImageFilePaths(_.filter(product.productImage, x => !x.isPrimary));
        setSampleVideoPath(product.sampleVideoPath);
        setSalesVideoPath(product.salesVideoPath);
        categoryId = product.categoryId;
        setProduct(product);
    }

    const LoadCompanies = (defaultCompanyId) => {
        if (role == "SuperAdmin") {
            CompanyService.GetAll().then(res => {
                setCompanies(res);
                let companySaved = res.find(x => x.id == defaultCompanyId);
                setSelectedCompany(Helper.SetOptionModel(companySaved.businessName, companySaved.id));
                setLoading(false);
            }).catch(ex => {
                setLoading(false);
            });
        }
        else
            LoadCategories(companyId);
    }

    const LoadCategories = (companyId) => {
        setLoading(true);
        setSelectedCategory(null);
        CategoryService.GetAll(companyId, false).then(res => {
            setCategories(res);
            if (categoryId > 0) {
                let categorySaved = res.find(x => x.id == categoryId);
                setSelectedCategory(Helper.SetOptionModel(categorySaved.name, categorySaved.id))
            }
            setLoading(false);
        }).catch(ex => {
            setLoading(false);
        });
    }

    const DeleteProductImage = (productImageId) => {
        ProductService.DeleteProductImage(productImageId)
            .then(res => {
                Alert({ success: true, message: 'Image has been removed!' });
            }).catch(ex => { });
    }

    const DeleteProductVideo = (videoUrl) => {
        console.log(videoUrl);
        ProductService.DeleteProductVideo(productId, videoUrl).then(res => {
            Alert({ success: true, message: 'Video has been removed!' });
        }).catch(ex => { });
    }

    const checkName = (e) => {
        clearTimeout(timeoutId);
        setIsChecking(true);
        timeoutId = setTimeout(() => {
            formik.setFieldTouched('name');
            if (e != undefined && e.target.value == product.name) {
                setIsUsed(false);
                setIsChecking(false);
            }
            else
                ProductService.Check(e == undefined ? formik.values.name : e.target.value, selectedCompany >= 0 ? selectedCompany : selectedCompany.value).then(res => {
                    setIsUsed(res);
                    setIsChecking(false);
                });
        }, 300);
    }

    const CreateProduct = (values, setSubmitting) => {
        if (isUsed)
            return;
        setLoading(true);
        setSubmitting(true);
        ProductService.Save(Helper.ConvertJsonToFormData({
            ...values,
            sampleVideoPath: sampleVideoPath,
            salesVideoPath: salesVideoPath,
            primaryImageFile: primaryImageFile ? primaryImageFile[0].file : null,
            imageFiles: imageFiles ? imageFiles.map(x => x.file) : null,
            sampleVideoFile: sampleVideoFile ? sampleVideoFile[0].file : null,
            salesVideoFile: salesVideoFile ? salesVideoFile[0].file : null
        }))
            .then(res => {
                SetDataFromProduct(res);
                Alert({ success: true, message: "Product has been saved!" });
                props.history.push("/product/" + res.id);
                setSubmitting(false);
                setLoading(false);
                setPrimaryImageFile(null);
                setImageFiles(null);
            })
            .catch(ex => {
                setSubmitting(false);
                setLoading(false);
            })
    }

    const formik = useFormik({
        initialValues: product,
        enableReinitialize: true,
        validationSchema: ProductCreateValidator,
        onSubmit: (values, { setSubmitting }) => {
            CreateProduct(values, setSubmitting);
        }
    })

    const includeImageInSummary = (id, isActive) => {
        ProductService.SetProductImageIncludeInSummary(id, isActive).then((res) => {
            Alert({ success: true, message: "Sample Image has been updated!" });
        }).catch(ex => {
            Alert({ success: false, message: ex.message });
        })
    }

    const SortSampleImages = async () => {
        setLoading(true);

        ProductService.SortSampleImages(sortList).then(async (res) => {
            await GetProductById();
            Alert({ success: true, message: res.message });
            setIsSortModalOpen(false);
        }).catch((ex) => {
            Alert({ success: false, message: ex.message });
        }).finally(() => {
            setLoading(false);
        });
    };

    const onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }

        const tempArr = Helper.ReOrderDnd(
            sortList,
            result.source.index,
            result.destination.index
        );

        setSortList(tempArr);
    };

    return (
        <>
            {
                loading ?
                    <LoadingScreen /> :
                    <CustomBlock className="main-container light--bg">
                        <Section>
                            <CustomBlock className="content-container--card-style content">
                                <ContentHeader
                                    title={product.id == 0 ? "Add New Product" : "Update Product"}
                                    headerSize="sm"
                                />
                                <FormBlock onSubmit={formik.handleSubmit}>
                                    <Section removeContainer>
                                        {
                                            role == 'SuperAdmin' ?
                                                <ContentBlock>
                                                    <SelectBlock
                                                        id="companyId"
                                                        name="companyId"
                                                        inputLabel="Company"
                                                        bordered
                                                        options={companies.map(x => Helper.SetOptionModel(x.businessName, x.id))}
                                                        value={selectedCompany}
                                                        onBlur={() => formik.setFieldTouched("companyId")}
                                                        onChange={option => {
                                                            option = option === null ? [] : option;
                                                            setSelectedCompany(option);
                                                            formik.setFieldValue("companyId", option.value);
                                                            LoadCategories(option.value);
                                                        }}
                                                        inputState={
                                                            formik.touched.companyId && formik.errors.companyId
                                                                ? "error"
                                                                : formik.touched.companyId && formik.errors.companyId == null
                                                                    ? "success"
                                                                    : ""
                                                        }
                                                        errorMessage={formik.errors.companyId}
                                                    />
                                                </ContentBlock> : <></>
                                        }
                                        <ContentBlock cols={4}>
                                            <InputBlock
                                                id="name"
                                                inputLabel="Product Name"
                                                bordered
                                                {...formik.getFieldProps("name")}
                                                inputState={
                                                    selectedCompany == 0 ? "disabled" :
                                                        formik.touched.name && (formik.errors.name || isUsed)
                                                            ? "error"
                                                            : formik.touched.name && formik.errors.name == null && !isUsed ? "success" : ""
                                                }
                                                errorMessage={isUsed ? "Name is already in use!" : formik.errors.name}
                                                onKeyUp={checkName}
                                                loading={isChecking}
                                                disabled={isDisabled}
                                            />
                                        </ContentBlock>

                                        <ContentBlock cols={4}>
                                            <SelectBlock
                                                id="categoryId"
                                                name="categoryId"
                                                inputLabel="Category"
                                                bordered
                                                options={categories.map(x => Helper.SetOptionModel(x.name, x.id))}
                                                value={selectedCategory}
                                                onBlur={() => formik.setFieldTouched("categoryId")}
                                                onChange={option => {
                                                    option = option === null ? [] : option;
                                                    setSelectedCategory(option);
                                                    formik.setFieldValue("categoryId", option.value);
                                                }}
                                                inputState={
                                                    selectedCompany == 0 ? "disabled" :
                                                        formik.touched.categoryId && formik.errors.categoryId
                                                            ? "error"
                                                            : formik.touched.categoryId && formik.errors.categoryId == null
                                                                ? "success"
                                                                : ""
                                                }
                                                errorMessage={formik.errors.categoryId}
                                                disabled={isDisabled}
                                            />
                                        </ContentBlock>

                                        <ContentBlock cols={2}>
                                            <InputBlock
                                                id="audienceSize"
                                                inputLabel="Audience Size"
                                                bordered
                                                {...formik.getFieldProps("audienceSize")}
                                                inputState={
                                                    selectedCompany == 0 ? "disabled" :
                                                        formik.touched.audienceSize && formik.errors.audienceSize
                                                            ? "error"
                                                            : formik.touched.audienceSize && formik.errors.audienceSize == null ? "success" : ""
                                                }
                                                errorMessage={formik.errors.audienceSize}
                                                disabled={isDisabled}
                                            />
                                        </ContentBlock>

                                        <ContentBlock cols={2}>
                                            <InputBlock
                                                id="price"
                                                inputLabel="Price"
                                                bordered
                                                {...formik.getFieldProps("price")}
                                                inputState={
                                                    selectedCompany == 0 ? "disabled" :
                                                        formik.touched.price && formik.errors.price
                                                            ? "error"
                                                            : formik.touched.price && formik.errors.price == null ? "success" : ""
                                                }
                                                errorMessage={formik.errors.price}
                                                disabled={isDisabled}
                                            />
                                        </ContentBlock>

                                        <ContentBlock>
                                            <TextAreaBlock
                                                id="description"
                                                inputLabel="Description"
                                                bordered
                                                {...formik.getFieldProps("description")}
                                                inputState={selectedCompany == 0 ? "disabled" : ""}
                                                disabled={isDisabled}
                                            />
                                        </ContentBlock>

                                        <ContentBlock>
                                            <TextAreaBlock
                                                id="specs"
                                                inputLabel="Specs"
                                                bordered
                                                {...formik.getFieldProps("specs")}
                                                inputState={selectedCompany == 0 ? "disabled" : ""}
                                                disabled={isDisabled}
                                            />
                                        </ContentBlock>

                                        <ContentBlock>
                                            <TextAreaBlock
                                                id="whyChoseThisTactic"
                                                inputLabel="Why we chose this tactic"
                                                bordered
                                                {...formik.getFieldProps("whyChoseThisTactic")}
                                                inputState={selectedCompany == 0 ? "disabled" : ""}
                                                disabled={isDisabled}
                                            />
                                        </ContentBlock>

                                        <ContentBlock cols={12}>
                                            <FileUploadBlock
                                                clearAction
                                                labelIdle='Upload Primary Image'
                                                path={primaryImagePath}
                                                onupdatefiles={setPrimaryImageFile}
                                                disabled={isDisabled}
                                                onClick={DeleteProductImage}
                                            />
                                        </ContentBlock>
                                        {
                                            (productId && imageFilePaths?.length > 0) ? (
                                                <Button
                                                    text="Sort Sample Images"
                                                    className="info--bg fit-content"
                                                    onClick={() => {
                                                        setIsSortModalOpen(true);
                                                    }}
                                                />
                                            ) : <></>
                                        }

                                        <ContentBlock cols={12}>
                                            <FileUploadBlock
                                                clearAction
                                                hasCheckbox
                                                labelIdle='Upload Sample Images'
                                                allowMultiple
                                                path={imageFilePaths}
                                                onupdatefiles={setImageFiles}
                                                disabled={isDisabled}
                                                onClick={DeleteProductImage}
                                                checkboxAction={includeImageInSummary}
                                            />
                                        </ContentBlock>

                                        <ContentBlock cols={6}>
                                            <strong style={{
                                                alignItems: 'center',
                                                display: 'flex',
                                                flexDirection: 'column',
                                            }}>Client Facing</strong>
                                            <FileUploadBlock
                                                clearAction
                                                type='video'
                                                setVideoPath={setSampleVideoPath}
                                                labelIdle='Upload Sample Video'
                                                videoUrl={sampleVideoPath}
                                                onupdatefiles={setSampleVideoFile}
                                                disabled={isDisabled}
                                                onClick={DeleteProductVideo}
                                            />
                                        </ContentBlock>

                                        <ContentBlock cols={6}>
                                            <strong style={{
                                                alignItems: 'center',
                                                display: 'flex',
                                                flexDirection: 'column',
                                            }}>Sales Video</strong>
                                            <FileUploadBlock
                                                clearAction
                                                type='video'
                                                setVideoPath={setSalesVideoPath}
                                                labelIdle='Upload Sales Video'
                                                videoUrl={salesVideoPath}
                                                onupdatefiles={setSalesVideoFile}
                                                disabled={isDisabled}
                                                onClick={DeleteProductVideo}
                                            />
                                        </ContentBlock>

                                        <ContentBlock>
                                            <TextAreaBlock
                                                id="bestUsedFor"
                                                inputLabel="Best Used For"
                                                bordered
                                                {...formik.getFieldProps("bestUsedFor")}
                                                inputState={selectedCompany == 0 ? "disabled" : ""}
                                                disabled={isDisabled}
                                            />
                                        </ContentBlock>

                                        <ContentBlock
                                            cols={6}
                                            className="padding-vertical"Desc
                                        >
                                            <CheckboxBlock
                                                label="Is product active?"
                                                id="is-ative-checkbox"
                                                defaultChecked={formik.values.isActive}
                                                {...formik.getFieldProps("isActive")}
                                                disabled={isDisabled}
                                            />

                                            <CheckboxBlock
                                                label="Uses Input?"
                                                id="uses-input-checkbox"
                                                defaultChecked={formik.values.usesFreeInput}
                                                {...formik.getFieldProps("usesFreeInput")}
                                                disabled={isDisabled}
                                            />
                                        </ContentBlock>

                                        <ContentBlock
                                            cols={6}
                                            className="padding-vertical"
                                        >
                                            <CheckboxBlock
                                                label="Can be bought with bonus points?"
                                                id="can-be-bonus-checkbox"
                                                defaultChecked={formik.values.canBeBonus}
                                                {...formik.getFieldProps("canBeBonus")}
                                                disabled={isDisabled}
                                            />

                                            <CheckboxBlock
                                                label="Has service duration?"
                                                id="has-service-duration-checkbox"
                                                defaultChecked={formik.values.hasServiceDuration}
                                                {...formik.getFieldProps("hasServiceDuration")}
                                                disabled={isDisabled}
                                            />
                                        </ContentBlock>

                                        <CustomBlock className="content-container--actions">
                                            <Button
                                                text="Cancel"
                                                to="/products"
                                                className="danger--bg fit-content"
                                            />
                                            {
                                                role == 'User' ? <></> :
                                                    <Button
                                                        text="Save"
                                                        type="submit"
                                                        className="success--bg fit-content"
                                                    />
                                            }
                                        </CustomBlock>
                                    </Section>
                                </FormBlock>
                            </CustomBlock>
                        </Section>

                        <Modal size="md" show={isSortModalOpen} onHide={() => setIsSortModalOpen(false)}>
                            <Modal.Header closeButton>
                                <Modal.Title>Sort Sample Images</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <p>Drag and Drop Image to Reorder</p>
                                {
                                    sortList.length > 0
                                        ? (
                                            <DragDropContext onDragEnd={onDragEnd}>
                                                <Droppable droppableId="droppable">
                                                    {(droppableProvided) => (
                                                        <div
                                                            ref={droppableProvided.innerRef}
                                                        >
                                                            {sortList.map((item, index) => (
                                                                <Draggable
                                                                    key={index} draggableId={`${index}`}
                                                                    index={index}
                                                                >
                                                                    {(draggableProvided) => (
                                                                        <div
                                                                            key={index}
                                                                            ref={draggableProvided.innerRef}
                                                                            {...draggableProvided.draggableProps}
                                                                            {...draggableProvided.dragHandleProps}
                                                                            className="content-container--card-style light-grey--sbg pt-15 pb-15 pl-20 pr-20 mb-15"
                                                                        >
                                                                            <img
                                                                                src={(constants.API_URL + 'Attachments' + item.imagePath)}
                                                                                height={200}
                                                                                width='auto'
                                                                                roundCorners
                                                                            />
                                                                        </div>

                                                                    )}
                                                                </Draggable>
                                                            ))}
                                                            {droppableProvided.placeholder}
                                                        </div>
                                                    )}
                                                </Droppable>
                                            </DragDropContext>
                                        ) : (
                                            <CustomBlock className="content-container--card-style light-grey--sbg pt-15 pb-15 pl-20 pr-20 mb-15">
                                                <p className="main-font fw-500">No Items Available</p>
                                            </CustomBlock>
                                        )
                                }
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    text="Close"
                                    className="danger--bg fit-content"
                                    onClick={() => {
                                        setIsSortModalOpen(false);
                                    }}
                                />
                                <Button
                                    text="Save Changes"
                                    className="success--bg fit-content"
                                    onClick={SortSampleImages}
                                />
                            </Modal.Footer>
                        </Modal>
                    </CustomBlock>
            }
        </>
    );
}

export default CreateNewProductPage;